import { axiosService } from '..';

export default class DisableBusinessFrontPageSlugService {
    public async execute(businessId: number, unpublishAllBusinessReferences: boolean): Promise<DisableBusinessFrontPageSlugServiceOutputDto> {
        const response = await axiosService.instance.post(`businesses/organization/front-page/${businessId}/disable-slug?unpublishAllBusinessReferences=${unpublishAllBusinessReferences.toString()}`);
        return new DisableBusinessFrontPageSlugServiceOutputDto(response.data.result, response.data.hasPublishedReferences);
    }
}

export class DisableBusinessFrontPageSlugServiceOutputDto {
    public readonly result: boolean;
    public readonly hasPublishedReferences: boolean | null;

    constructor(result: boolean, hasPublishedReferences: boolean | null) {
        this.result = result;
        this.hasPublishedReferences = hasPublishedReferences;
    }
}

export const disableBusinessFrontPageSlugService = new DisableBusinessFrontPageSlugService();
